import React from 'react'

import type { TagProps } from '@fourthwall/components'
import { Button, Tag, useMediaQueryContext } from '@fourthwall/components'

import { DomainString } from '../DomainString/DomainString'
import * as S from './CurrentDomain.styled'

type CurrentDomainProps = {
  domain: string
  tag?: Pick<TagProps, 'label' | 'appearance'>
  claimLabel?: string
  isClaiming: boolean
  onClaim?: () => void
}

export const CurrentDomain = ({
  domain,
  tag,
  claimLabel = 'Claim',
  isClaiming,
  onClaim,
}: CurrentDomainProps) => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      <S.Content>
        <S.DomainName>
          <DomainString domain={domain} />
        </S.DomainName>

        {tag && <Tag {...tag} />}
      </S.Content>

      {onClaim && (
        <Button
          appearance="primary"
          size="small"
          fullWidth={!media.tablet}
          label={claimLabel}
          loading={isClaiming}
          onClick={onClaim}
        />
      )}
    </S.Container>
  )
}
